import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PillItem, UsernameAlt } from "../../helpers";
import { getUiDateTime } from "../../../helpers/DateUtils";
import { Username } from "../../helpers";
import Field from "../../Field";
import _ from "lodash";

const getContactLines = (contact = {}) => {
	return [contact?.name, contact?.phone, contact?.email].filter(
		(value) => typeof value === "string" && value.trim().length > 0,
	);
};

const SchemeDetails = ({ schemeData }) => {
	const { t } = useTranslation();

	//Local State
	const [schemeUsers, setSchemeUsers] = useState([]);

	useEffect(() => {
		const sortUsers = _.groupBy(schemeData.users.items, "role");
		setSchemeUsers(sortUsers);
	}, [schemeData]);

	return (
		<>
			<section className="grid columns-2 gap-large">
				<div className="grid columns-label gapCol-medium gapRow-xsmall aItems-center aContent-start">
					<span>{t("admin.scheme.common.name")}:</span>
					<span>{schemeData.name}</span>
					<span>{t("admin.scheme.common.id")}:</span>
					<span>{schemeData.id}</span>
				</div>
				<div className="grid columns-2 gapCol-medium">
					<div className="grid columns-label gapCol-medium gapRow-xsmall aItems-center aContent-start">
						<span>{t("common.table.createdAt")}:</span>
						<span>{getUiDateTime(schemeData.createdAt)}</span>
						<span>{t("common.table.createdBy")}:</span>
						<span>{schemeData.createdBy && <Username sub={schemeData.createdBy} />}</span>
					</div>
					<div className="grid columns-label gapCol-medium gapRow-xsmall aItems-center aContent-start">
						<span>{t("common.table.updatedAt")}:</span>
						<span>{getUiDateTime(schemeData.updatedAt)}</span>
						<span>{t("common.table.updatedBy")}:</span>
						<span>{schemeData.updatedBy && <Username sub={schemeData.updatedBy} />}</span>
					</div>
				</div>
				<div className="grid columns-2-AutoFree gapCol-small gapRow-xsmall">
					<Field
						label="Contact"
						response={
							getContactLines(schemeData.contact).length > 0 ? (
								<div className="flexVert">
									{getContactLines(schemeData.contact).map((line, idx) => (
										<span key={`contact-${idx}`}>{line}</span>
									))}
								</div>
							) : (
								<span>{t("admin.scheme.details.contact.notSet")}</span>
							)
						}
					/>
				</div>
				<div className="grid columns-2-AutoFree gapCol-small gapRow-xsmall">
					<Field
						label="Emergency Contact"
						response={
							getContactLines(schemeData.contactEmergency).length > 0 ? (
								<div className="flexVert">
									{getContactLines(schemeData.contactEmergency).map((line, idx) => (
										<span key={`contact-emergency-${idx}`}>{line}</span>
									))}
								</div>
							) : (
								<span>{t("admin.scheme.details.contact.notSet")}</span>
							)
						}
					/>
				</div>
			</section>
			<section>
				<div className="card">
					<header>
						<h3>{t("admin.scheme.details.users.header")}</h3>
					</header>
					<div className="grid columns-3 gap-medium">
						<div>
							<PillItem type="text" value={t(`user.role.OWNER`)} wrapperStyle="blue1" />
							<div className="flexVert gapRow-xsmall marginTop-xsmall">
								{schemeUsers?.OWNER?.map((u) => (
									<UsernameAlt key={u.cognitoUserId} sub={u.cognitoUserId} link />
								))}
							</div>
						</div>
						<div>
							<PillItem type="text" value={t(`user.role.TENANT`)} wrapperStyle="blue1" />
							<div className="flexVert gapRow-xsmall marginTop-xsmall">
								{schemeUsers?.TENANT?.map((u) => (
									<UsernameAlt key={u.cognitoUserId} sub={u.cognitoUserId} link />
								))}
							</div>
						</div>
						<div>
							<PillItem type="text" value={t(`user.role.INSTALLER`)} wrapperStyle="blue1" />
							<div className="flexVert gapRow-xsmall marginTop-xsmall">
								{schemeUsers?.INSTALLER?.map((u) => (
									<UsernameAlt key={u.cognitoUserId} sub={u.cognitoUserId} link />
								))}
							</div>
						</div>
					</div>
					{/* <div className="grid columns-2-AutoFree gapCol-medium gapRow-small aItems-center">
						{schemeData.users.items.map((u) => (
							<React.Fragment key={u.cognitoUserId}>
								<Username sub={u.cognitoUserId} link />
								<PillItem type="text" value={t(`user.role.${u.role}`)} wrapperStyle="blue1" />
							</React.Fragment>
						))}
					</div> */}
				</div>
			</section>
		</>
	);
};

export default SchemeDetails;
